import Toastify from "../custom_js/toastify.js";

up.compiler(".up_link_copied", function (element, data) {
  function clipboardAndToast() {
    navigator.clipboard.writeText(
      document.querySelector("link[rel='canonical']").getAttribute("href")
    );
    Toastify({
      text: "Lien copié",
      progressBar: true,
      progressBarStyle: {
        background: "gray",
        barBackground: data.color || "#23d166",
        height: "5px",
      },
      progressBarPosition: "bottom",
      duration: 3000,
      close: true,
      gravity: data.gravity || "top",
      position: "center",
      stopOnFocus: true,
      offset: {
        y: "65px",
      },
    }).showToast();
  }

  element.addEventListener("click", clipboardAndToast);
  return () => {
    element.removeEventListener("click", clipboardAndToast);
  };
});
